import { Controller } from "@hotwired/stimulus";
import A11yDialog from "a11y-dialog";

export default class extends Controller<HTMLDialogElement> {
  dialog?: A11yDialog;

  connect() {
    document.addEventListener("turbo:before-cache", this.reset);
    this.dialog = new A11yDialog(this.element);
    this.dialog
      .on("show", () => {
        document.documentElement.style.overflowY = "hidden";
        this.element.setAttribute("open", "");
      })
      .on("hide", () => {
        document.documentElement.style.overflowY = "";
        this.element.removeAttribute("open");
      });
  }

  disconnect() {
    document.documentElement.style.overflowY = "";
    this.dialog?.destroy();
    document.removeEventListener("turbo:before-cache", this.reset);
  }

  reset = () => {
    this.dialog?.hide();
  };

  show() {
    this.dialog?.show();
  }

  hide() {
    this.dialog?.hide();
  }
}
